module.exports = __webpack_public_path__ + "img/img-main-bg07.a1cc5b14.png";